import { render, staticRenderFns } from "./WelcomeStep.vue?vue&type=template&id=1bb084a0&scoped=true"
import script from "./WelcomeStep.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeStep.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WelcomeStep.vue?vue&type=style&index=0&id=1bb084a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb084a0",
  null
  
)

export default component.exports